import {createContext} from 'react'

import Logger from './Logger'

const noopLogger = new Logger([])

export default createContext<Logger>(noopLogger)
